import { doc, getDoc, getFirestore, updateDoc } from 'firebase/firestore';

/** Patch a single tour day in the user's folder and persist to Firestore. */
export async function updateTourDayFields(uid, tourId, dayIndex, patch) {
  if (!uid || !tourId || dayIndex == null || dayIndex < 0 || !patch) {
    throw new Error('Missing tour day update parameters.');
  }
  const db = getFirestore();
  const userRef = doc(db, 'users', uid);
  const snap = await getDoc(userRef);
  if (!snap.exists()) throw new Error('User not found.');
  const folders = { ...(snap.data()?.folders || {}) };
  const folder = folders[tourId];
  if (!folder?.tour?.days?.[dayIndex]) throw new Error('Tour day not found.');
  const days = [...folder.tour.days];
  days[dayIndex] = { ...days[dayIndex], ...patch };
  folders[tourId] = { ...folder, tour: { ...folder.tour, days } };
  await updateDoc(userRef, { folders });
  return days[dayIndex];
}
